import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useClientId } from "../context/context.js";

const apiBaseUrl = process.env.REACT_APP_API_URL;

export function useDocuments() {
  const clientId = useClientId();
  const queryClient = useQueryClient();

  const emailMarinaAuthorizationMutation = useMutation({
    mutationFn: ({ name, mailingAddress, propertyAddress, emailAddress, signature }) =>
      axios.post(`${apiBaseUrl}/clients/${clientId}/send-marina-authorization`, {
        name,
        mailingAddress,
        propertyAddress,
        emailAddress,
        signature,
      }).then(res => res.data),
    onError: (error) => {
      console.error("Error emailing marina authorization:", error);
    }
  });

  const emailMarinaAuthorization = useMutation({
        mutationFn: emailMarinaAuthorizationMutation.mutate,
        onSuccess: (data) => {
            console.log('Email Confirmation Sent', data);
        },
        onError: (error) => console.error("Error sending email confirmation:", error),
  });

  const fetchMarinaAuthorization = async () => {
    const response = await axios.get(
      `${apiBaseUrl}/clients/${clientId}/fetch-marina-authorization`,
      { responseType: "blob" }
    );
    return URL.createObjectURL(response.data);
  };

  return {
    emailMarinaAuthorization,
    fetchMarinaAuthorization,
  };
}
